import { TextButtonIcon } from './TextButtonIcon';

// TODO: in v9, move styled() from TextButtonIcon.jsx to here
export var StyledTextButtonIcon = TextButtonIcon;